import { graphql } from "@/gql";

export const generateIncidentPdfMutation = graphql(`
  mutation GenerateIncidentPdf($id: ID!) {
    generateIncidentPdf(id: $id) {
      id
      url
    }
  }
`);
